import { render, staticRenderFns } from "./cmp-dialog-login.vue?vue&type=template&id=522d5854&scoped=true"
import script from "./cmp-dialog-login.vue?vue&type=script&lang=js"
export * from "./cmp-dialog-login.vue?vue&type=script&lang=js"
import style0 from "./cmp-dialog-login.vue?vue&type=style&index=0&id=522d5854&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522d5854",
  null
  
)

export default component.exports